import wrapWithProvider from './src/components/wrap-with-provider';
import './src/styles/global.css';
export const wrapRootElement = wrapWithProvider;

export const shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  const oldPath = prevRouterProps?.location?.pathname;
  const newPath = routerProps.location.pathname;
  return oldPath !== newPath;
};
